var map = {
	"./-1.svg": 3670,
	"./1.svg": 6714,
	"./10.svg": 7845,
	"./11.svg": 3049,
	"./12.svg": 2671,
	"./13.svg": 2977,
	"./14.svg": 6677,
	"./15.svg": 7102,
	"./16.svg": 7769,
	"./17.svg": 2407,
	"./18.svg": 3244,
	"./19.svg": 9909,
	"./2.svg": 7316,
	"./20.svg": 9342,
	"./21.svg": 4599,
	"./22.svg": 2355,
	"./23.svg": 6671,
	"./24.svg": 2009,
	"./25.svg": 3071,
	"./26.svg": 6553,
	"./27.svg": 986,
	"./28.svg": 511,
	"./29.svg": 9881,
	"./3.svg": 7281,
	"./30.svg": 1583,
	"./31.svg": 6703,
	"./32.svg": 9856,
	"./33.svg": 8557,
	"./34.svg": 453,
	"./36.svg": 1889,
	"./37.svg": 7954,
	"./38.svg": 7505,
	"./39.svg": 1159,
	"./4.svg": 7060,
	"./40.svg": 9648,
	"./41.svg": 6628,
	"./42.svg": 3728,
	"./43.svg": 3953,
	"./44.svg": 849,
	"./45.svg": 7659,
	"./46.svg": 419,
	"./47.svg": 2538,
	"./48.svg": 8145,
	"./49.svg": 8822,
	"./5.svg": 8740,
	"./6.svg": 1456,
	"./7.svg": 5291,
	"./8.svg": 2571,
	"./9.svg": 1585
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 829;